import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/tvShows';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const mainCategories = categories.slice(0, 5);

  return (
    <header className="relative z-50">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || location.pathname !== '/'
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 shrink-0"
              aria-label="天堂影视首页"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <span className="text-background-50 font-bold text-lg leading-none">天</span>
              </div>
              <span className="text-xl font-bold text-foreground-900 font-heading whitespace-nowrap">
                天堂影视
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === '/'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                首页
              </Link>
              {mainCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === '/about'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索电视剧..."
                  className="pl-9 pr-4 py-2 text-sm rounded-full bg-background-100 text-foreground-800 placeholder-foreground-400 border border-background-200/70 focus:outline-none focus:border-primary-300 transition-colors w-48"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl text-foreground-800 ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 top-16 z-40 bg-background-50 md:hidden overflow-y-auto">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className={`block px-4 py-3 rounded-lg text-base ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 7).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`block px-4 py-3 rounded-lg text-base ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block px-4 py-3 rounded-lg text-base ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
            <div className="pt-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索电视剧..."
                  className="w-full pl-10 pr-4 py-3 text-sm rounded-full bg-background-100 text-foreground-800 placeholder-foreground-400 border border-background-200/70 focus:outline-none focus:border-primary-300"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}